import styled from 'styled-components'
import {Link} from 'react-router-dom';

export const Drawer = styled.div`
  display: ${props => props.open ? 'block' : 'none'};
  position: fixed; /* Stay in place */
  z-index: 5; /* Sit on top */
  //padding-top: 100px; /* Location of the box */
  margin:0;
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  // Display an opaque black background if the drawer is open. Remove it as soon as it starts to close.
  background-color: ${props => props.closing ? 'transparent' : 'rgba(0,0,0)'};
  background-color: ${props => props.closing ? 'transparent' : 'rgba(0,0,0,0.4)'}; 
`

export const DrawerContent = styled.div`

  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  overflow: auto; /* Enable scroll if needed */
  background-color: ${props => props.theme.colors.navBar};
  color: ${props => props.theme.colors.navBarText};
  margin: auto;
  width: 200px;
  height: 100%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);

  //animation-fill-mode: forwards;

  &.OpenDrawer {
    -webkit-animation: SlideIn 0.4s;
    animation: SlideIn 0.4s;
  }


  &.ClosedDrawer {
    -webkit-animation: SlideOut 0.4s;
    animation: SlideOut 0.4s;
    //left: -300px;
    //background-color: red;
  }

  @-webkit-keyframes SlideIn {
    from {left:-300px; opacity:0}
    to {left:0; opacity:1}
  }

  @keyframes SlideIn {
    from {left:-300px; opacity:0}
    to {left:0; opacity:1}
  }

  @-webkit-keyframes SlideOut {
    from {left: 0; opacity:1}
    to {left:-300px; opacity:0}
  }

  @keyframes SlideOut {
    from {left: 0; opacity:1}
    to {left:-300px; opacity:0}
  }

  .SideNav-header {
    padding: 16px 16px;
    display: flex;
    align-items: stretch;
  }

  .SideNav-header a{
    color: ${props => props.theme.colors.navBarText};
    text-decoration: none;
  }

  .SideNav-Header-item {
    display: block;
    color: #f2f2f2;
    text-align: center;
    padding: 14px 16px;
    font-size: 17px;
    //height: fit-content;
    //background-color: #4ba3c7;
  }

  .SideNav-icon {
    position: absolute;
    left: 0;
    top: 0;
  }
`;

const DrawerItem = styled(Link) `
  float:left;
  width:100%;
  outline:0;
  border:none;
  padding: 14px 16px;
  display:inline-block;
  vertical-align:middle;
  overflow:hidden;
  text-decoration:none;
  color:inherit;
  background-color:inherit;
  cursor:pointer;
  white-space:nowrap;

  &:hover {
    color: ${props => props.theme.colors.textOnDark} !important;
    background-color: ${props => props.theme.colors.navBarHover} !important;
`

const DrawerDropdown  = styled.div`
  float:left;
  width:100%;
  padding: 14px 16px;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.colors.textOnDark} !important;
    background-color: ${props => props.theme.colors.navBarHover} !important;
`

export {DrawerItem, DrawerDropdown}